Shopware.Component.register('sw-cms-preview-jga-revocation-button-block', () => import('./preview'));
Shopware.Component.register('sw-cms-block-jga-revocation-button', () => import('./component'));

Shopware.Service('cmsService').registerCmsBlock({
    name: 'jga-revocation-button',
    label: 'jga-revocation.cms.blockLabel',
    category: 'text',
    component: 'sw-cms-block-jga-revocation-button',
    previewComponent: 'sw-cms-preview-jga-revocation-button-block',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: '20px',
        marginRight: '20px',
        sizingMode: 'boxed',
    },
    slots: {
        content: 'jga-revocation-button',
    },
});
